import { render, staticRenderFns } from "./CampaignHistory.vue?vue&type=template&id=ceb3ba7c"
import script from "./CampaignHistory.vue?vue&type=script&lang=js"
export * from "./CampaignHistory.vue?vue&type=script&lang=js"
import style0 from "./CampaignHistory.vue?vue&type=style&index=0&id=ceb3ba7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports